//import { LOCATION_CHANGE } from 'react-router-redux';
import {
    SET_MODAL_BODY,
    REFRESH_VIEW
} from 'store/actions/listActions';
import {
    CRUD_DELETE_MANY_SUCCESS,
    CRUD_DELETE_MANY_FAILURE
} from 'store/actions/dataActions';
// import { 
//     TOP_MENU_CONTACT,
// } from 'util/constants';


const initialState = {};

export default (previousState = initialState, { type, payload }) => {

    switch (type) {
        // case LOCATION_CHANGE://다른 메뉴로 이동하는 경우 구조가 달라 에러발생하므로 초기화
        //     if( !payload.hash ) {
        //         return initialState;
        //     // 주소록의 경우 hash정보를 item object에 담음
        //     } else if( payload.pathname.indexOf(`/${TOP_MENU_CONTACT}/`) === 0 ) {
                
        //         const hashArrayInfo = payload.hash.substr(1, payload.hash.length-1).split("/");
        //         if( hashArrayInfo.length === 2 && !isNaN(hashArrayInfo[1]) ) {
        //             return {
        //                 modalType: 'form',
        //                 modalId: `${TOP_MENU_CONTACT}_${hashArrayInfo[0]}`,
        //                 keyValue: parseInt(hashArrayInfo[1], 10),
        //                 keyName: hashArrayInfo[0]+"Seq",
        //                 isFetch: hashArrayInfo[0] === "addr" ? true : false,
        //                 isHash: true
        //             }
        //         }
        //     }

        //     return previousState;
        

        case SET_MODAL_BODY:
            if( payload.modalType && payload.modalId ) {
                return { ...payload };
            } else {
                return initialState;
            }

        case CRUD_DELETE_MANY_SUCCESS:
        case CRUD_DELETE_MANY_FAILURE:
        case REFRESH_VIEW:
            return initialState;

        default:
            return previousState;
    }
    
};